import type { PositionalArgs } from 'ember-modifier';
import type AuthorizationService from 'volta/services/authorization';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { inject as service } from '@ember/service';

export interface CanViewSignature {
  Args: {
    Positional: [string, details?: string];
  };
  Return: boolean;
}

export default class CanView extends Helper<CanViewSignature> {
  @service authorization!: AuthorizationService;

  // eslint-disable-next-line ember/no-observers
  onPermissionsInit = observer('authorization.permissions', () => {
    this.recompute();
  });
  compute([entityType, details]: PositionalArgs<CanViewSignature>) {
    return this.authorization.canView(entityType, details);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'can-view': typeof CanView;
  }
}
